import { render, staticRenderFns } from "./numberfield.vue?vue&type=template&id=4ee384a7&"
import script from "./numberfield.vue?vue&type=script&lang=js&"
export * from "./numberfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports